<div class="access-denied-container">
  <span class="access-denied">Access Denied</span>
  <p>You do not have access to this application.</p>
  <div class="helpline">
      <span
      >For any login issues<br />
        Please contact Herc Rentals Service Desk at <br />
        866-4HERCIT (866-443-7248) or email
        <a href="mailto:HercServiceDesk@hercrentals.com">HercServiceDesk&#64;hercrentals.com</a></span
      >
  </div>
</div>
